(() => {
  const selector = '[data-stayai-onetime-price] > s';

  const parseLocalizedMoney = (value) => {
    const compact = value.replace(/\u00a0/g, '').replace(/\s/g, '').replace(/[^\d,.-]/g, '');
    const normalized = compact.includes(',') ? compact.replace(/\./g, '').replace(',', '.') : compact;
    return Number(normalized);
  };

  const updateZeroComparePrices = () => {
    document.querySelectorAll(selector).forEach((price) => {
      const amount = parseLocalizedMoney(price.textContent || '');
      price.classList.toggle('pfm-zero-compare-price', Number.isFinite(amount) && amount === 0);
    });
  };

  const initialize = () => {
    updateZeroComparePrices();

    let frame;
    new MutationObserver(() => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(updateZeroComparePrices);
    }).observe(document.body, { childList: true, characterData: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
